/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_Move_RightInputs */



/**
* | output |
* | --- |
* | "Move Right 1 Character" |
*
* @param {Input_Position_X_Move_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_move_right = /** @type {((inputs?: Input_Position_X_Move_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_Move_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacer à Droite de 1 Caractère")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewege dich um 1 Zeichen nach rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta a destra 1 carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместить вправо на 1 символ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover 1 carácter a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向右移动 1 个字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1文字右に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दाईं ओर 1 अक्षर आगे बढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mova 1 caractere para a direita")
	return /** @type {LocalizedString} */ ("Move Right 1 Character")
});